import { Component, Input } from '@angular/core';
import { DashboardPageDefinition } from '../../dashboard.data';

/** Chrome shared by every dashboard sub-page: heading, subtitle, filter bar, then the page's own content. */
@Component({
  selector: 'ifbp-dashboard-page-shell',
  templateUrl: './dashboard-page-shell.component.html',
  styleUrls: ['./dashboard-page-shell.component.scss'],
  standalone: false,
})
export class DashboardPageShellComponent {
  @Input() page: DashboardPageDefinition | null = null;
  /** Response time of the page's own data; drives the filter bar's freshness label. */
  @Input() asOfUtc: Date | null = null;
}
